import type { paths } from "@/api-schema";
import { optionsWithDefaults } from "@/common/api/_helpers/options-with-defaults";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { Options } from "../../_types";

export const CASAVI_SETTINGS_GET_RESOURCE = "casavi-settings" as const;
export const CASAVI_SETTINGS_GET_API_PATH = `/v1/${CASAVI_SETTINGS_GET_RESOURCE}` as const;

export type CasaviSettingsGetParameters = paths[typeof CASAVI_SETTINGS_GET_API_PATH]["get"]["parameters"]["query"];
export type CasaviSettingsGetResponse =
  paths[typeof CASAVI_SETTINGS_GET_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useCasaviSettingsGetQuery(options?: Options<CasaviSettingsGetParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<CasaviSettingsGetParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    queryKey: [CASAVI_SETTINGS_GET_RESOURCE, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<CasaviSettingsGetResponse>(`/v1/${CASAVI_SETTINGS_GET_RESOURCE}`, {
        params: requestParameters,
      });

      return response.data;
    },
  });
}
